<div>
  <video role="video" width="1600" height="840" controls autoplay class="video-popup">
    <source [src]="path" type="video/mp4" />
  </video>
</div>
